import httpClient from "@api/http";
import axios from "axios";

class ChallengePictureRepository {
  async addChallengePicture(challengeId: string, fileName: string) {
    const response = await httpClient.post(
      `/challenge/admin/${challengeId}/picture`,
      { fileName }
    );

    return response.data;
  }

  async deleteChallengePictures(challengeId: string, keys: string[]) {
    const response = await httpClient.delete(
      `/challenge/admin/${challengeId}/picture`,
      {
        data: {
          challengeId,
          keys,
        },
      }
    );

    return response.data;
  }

  async uploadChallengePicturePresignedUrl(url: string, picture: File) {
    try {
      const contentType = picture.type || 'image/jpeg';
      
      const response = await axios.put(url, picture, {
        headers: {
          "Content-Type": contentType,
          Accept: "*/*",
        },
      });
      
      if (response.status !== 200) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }
      
      console.log("File uploaded successfully");
      return response;
    } catch (error) {
      console.error("File upload failed:", error);
      throw new Error(`File upload failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}

export default new ChallengePictureRepository();
